import { useEffect } from "react";
import { motion } from "framer-motion";

export default function SplashScreen({ onDone }) {
  useEffect(() => {
    const t = setTimeout(() => onDone && onDone(), 2100);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="splash-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.7, ease: "easeInOut" }}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050505] overflow-hidden"
    >
      {/* gold glow orb */}
      <div
        className="absolute w-[520px] h-[520px] rounded-full blur-[120px]"
        style={{ background: "radial-gradient(circle, rgba(212,175,55,0.22), transparent 70%)", animation: "dlx-glow-pulse 3s ease-in-out infinite" }}
      />
      <img src="/deluxe-logo-main.jpeg" alt="DELUXE"
        className="relative w-44 sm:w-56 opacity-0"
        style={{ animation: "dlx-fade-up .9s .2s cubic-bezier(.22,1,.36,1) forwards" }} />

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7, duration: 0.7 }}
        className="relative -mt-2 flex flex-col items-center"
      >
        <span className="font-serif text-3xl sm:text-4xl uppercase tracking-[0.34em] text-white">
          DELU<span className="dlx-shimmer">X</span>E
        </span>
        <div className="mt-3 h-px w-36 dlx-hairline" />
        <span className="mt-3 font-sans text-[11px] uppercase tracking-[0.5em] text-zinc-500">
          Trading Analytics
        </span>
        <span className="mt-6 font-mono text-[11px] tracking-widest text-gold/70">
          Niccolò Picco <span className="text-zinc-600">×</span> Diego Leccioli
        </span>
      </motion.div>

      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay: 0.4, duration: 1.6, ease: "easeInOut" }}
        className="absolute bottom-24 h-px w-40 origin-left"
        style={{ background: "linear-gradient(90deg,transparent,rgba(212,175,55,.6),transparent)" }}
      />
    </motion.div>
  );
}
